import {
  Spacing
} from 'UI'

export default {
  learningPathCol: {
    marginBottom: 32,
    '& > a': {
      display: 'block',
      width: '100%',
      textDecoration: 'none'
    },
    '& > a:hover, & > a:visited, & >  a:link, & >  a:active': {
      textDecoration: 'none'
    }
  },
  responsiveRow: {
    overflow: 'auto',
    flexWrap: 'nowrap !important',
    marginRight: '-15px !important',
    margin: ({ margin }) => margin || Spacing(0, 0, 5, 0)
  },
  responsiveCard: {
    margin: () => Spacing(0, 5, 0, 0),
    minWidth: 'calc(80% - 15px)',
    maxWidth: 'calc(70% - 15px)'
  }
}
